import EditNoteIcon from "@mui/icons-material/EditNote";
import SaveIcon from "@mui/icons-material/Save";
import { LoadingButton } from "@mui/lab";
import { Grid, IconButton } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import { FormikProps, useFormik } from "formik";
import * as React from "react";
import * as yup from "yup";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import CustomAlerts from "../../../common/feedback/alerts";
import MessageResponse from "../../../common/feedback/messageResponse";
import { GetMessageReponse } from "../../../common/Logic/ServerResponse";
import { FeedbackDto } from "../../../common/models/requests/FeedbackDto";
import { AllApplicantDto, PersonalDetailsDto } from "../../applicant/Models";
import { selectAdmin } from "../adminSlice";
import { UpdatePersonalDetailsThunk } from "../thunks";

interface Props {
  application: AllApplicantDto;
}
export default function EditApplication({ application }: Props) {
  const [open, setOpen] = React.useState(false);
  const dispatch = useAppDispatch();
  const adminAction = useAppSelector(selectAdmin);
  const [feedback, setFeedback] = React.useState<FeedbackDto>(
    {} as FeedbackDto
  );

  const handleClickOpen = () => {
    setFeedback({} as FeedbackDto);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const validationSchema = yup.object({});

  const initialValues = {} as PersonalDetailsDto;

  const formik: FormikProps<PersonalDetailsDto> = useFormik<PersonalDetailsDto>(
    {
      initialValues: initialValues,
      enableReinitialize: true,
      validationSchema: validationSchema,
      onSubmit: (values: PersonalDetailsDto) => {
        dispatch(UpdatePersonalDetailsThunk(values)).then((resp) => {
          if (
            adminAction.applicationDatesState.status === "failed" ||
            resp.payload?.errors ||
            resp.payload?.validation.code !== 200
          ) {
            const feed = GetMessageReponse(
              adminAction.applicationDatesState.error,
              false,
              resp.type
            );

            setFeedback(feed);
            return;
          }

          if (
            (resp.type.includes("fulfilled") &&
              resp.payload?.validation?.code === 201) ||
            (resp.type.includes("fulfilled") &&
              resp.payload?.validation?.code === 200)
          ) {
            const feed = GetMessageReponse(resp.payload, true, resp.type);
            setFeedback(feed);

            setTimeout(() => {
              setOpen(false);
            }, 2000);
          }
        });
      },
    }
  );

  const loadPersonalDetails = () => {
    const personalDetails = application?.personalDetails;

    if (personalDetails) {
      formik.setFieldValue("email", personalDetails.email);
      formik.setFieldValue("gender", genderEnums(personalDetails.gender));
      formik.setFieldValue("identityNumber", personalDetails.identityNumber);
      formik.setFieldValue("isStepCompleted", personalDetails.isStepCompleted);
      formik.setFieldValue("name", personalDetails.name);
      formik.setFieldValue("phoneNumber", personalDetails.phoneNumber);
      formik.setFieldValue("race", raceEnums(personalDetails.race));
      formik.setFieldValue("surname", personalDetails.surname);
      formik.setFieldValue("applicationId", application.applicationId);
    }
  };

  const raceEnums = (race: string) => {
    switch (race) {
      case "African":
        return 1;
      case "White":
        return 2;
      case "Indian":
        return 3;
      case "Coloured":
        return 4;

      default:
        break;
    }
  };

  const genderEnums = (gender: string) => {
    switch (gender) {
      case "Male":
        return 1;
      case "Female":
        return 2;
      case "Other":
        return 3;
      default:
        break;
    }
  };

  React.useEffect(() => {
    loadPersonalDetails();
  }, [application]);

  return (
    <>
      <IconButton onClick={handleClickOpen}>
        <EditNoteIcon />
      </IconButton>
      <Dialog open={open} fullWidth maxWidth="lg">
        <DialogTitle>Update Applicant</DialogTitle>
        <DialogContent>
          <DialogContentText mb={2}></DialogContentText>

          <CustomAlerts feedback={feedback} setFeedback={setFeedback} />
          <MessageResponse feedback={feedback}/>
          {application && (
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  id="name"
                  name="name"
                  label="Enter your names"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  type="text"
                  error={formik.touched.name && Boolean(formik.errors.name)}
                  helperText={formik.touched.name && formik.errors.name}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  id="surname"
                  name="surname"
                  label="Enter your Surname"
                  value={formik.values.surname}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  type="text"
                  error={
                    formik.touched.surname && Boolean(formik.errors.surname)
                  }
                  helperText={formik.touched.surname && formik.errors.surname}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  id="identityNumber"
                  name="identityNumber"
                  label="Enter your Identity Number"
                  value={formik.values.identityNumber}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  type="text"
                  error={
                    formik.touched.identityNumber &&
                    Boolean(formik.errors.identityNumber)
                  }
                  helperText={
                    formik.touched.identityNumber &&
                    formik.errors.identityNumber
                  }
                />
              </Grid>

              {/* <Grid item xs={12} md={6}>
              <Gender
                formik={formik}
                isDisabled={
                  personalDetails ? personalDetails.isStepCompleted : false
                }
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Race
                formik={formik}
                isDisabled={
                  personalDetails ? personalDetails.isStepCompleted : false
                }
              />
            </Grid> */}

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  id="email"
                  name="email"
                  label="Enter your Email Address"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  type="text"
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  helperText={formik.touched.email && formik.errors.email}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  id="phoneNumber"
                  name="phoneNumber"
                  label="Enter your phone number"
                  value={formik.values.phoneNumber}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  type="text"
                  error={
                    formik.touched.phoneNumber &&
                    Boolean(formik.errors.phoneNumber)
                  }
                  helperText={
                    formik.touched.phoneNumber && formik.errors.phoneNumber
                  }
                />
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>

          <LoadingButton
            color="info"
            variant="outlined"
            size="medium"
            startIcon={<SaveIcon />}
            onClick={() => {
              formik.submitForm();
            }}
            loading={adminAction.applicationDatesState.status === "loading"}
            loadingPosition="start"
          >
            Update
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
}
